import Vue from 'vue';
import Vuex from 'vuex';
import App from './app';
import Device from './modules/device/index';
import Engineering from './modules/engineering/index';
import Authority from './modules/authority/index'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    App,
    Device,
    Engineering,
    Authority,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js